import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { PageHeader } from "../components/Shared";
import { formatRupiah } from "../data";
import { translations } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MenuPage({ navigate, lang }) {
  const T = translations[lang];
  const [cat, setCat] = useState("all");
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    fetch(`${API}/menu`)
      .then((r) => (r.ok ? r.json() : []))
      .then(setMenuItems)
      .catch(() => setMenuItems([]));
  }, []);

  const items = cat === "all" ? menuItems : menuItems.filter((i) => i.category === cat);

  return (
    <div className="flex flex-col min-h-screen" data-testid="menu-screen">
      <PageHeader title={T.menuTitle} onBack={() => navigate("dashboard")} />

      <div className="bg-white sticky top-0 z-10 px-4 py-3 border-b border-[#F0F7FF]">
        <div className="flex gap-2 overflow-x-auto hide-scrollbar">
          {T.categories.map((c) => (
            <button
              key={c.key}
              data-testid={`menu-tab-${c.key}`}
              onClick={() => setCat(c.key)}
              className={`text-[14px] font-medium whitespace-nowrap px-4 py-2 rounded-full transition-all duration-200 ${
                cat === c.key
                  ? "bg-[#4AADDF] text-white shadow-[0_4px_12px_rgba(74,173,223,0.3)]"
                  : "bg-[#F0F7FF] text-[#6B7B8D]"
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex-1 px-4 py-4 pb-[150px] space-y-3">
        {items.map((it, i) => (
          <motion.div
            key={it.id || it.name}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.03, duration: 0.25 }}
            className="bg-white rounded-[16px] shadow-[0_2px_12px_rgba(74,173,223,0.08)] p-4 border border-[#F0F7FF]"
            data-testid="menu-item"
          >
            <div className="flex justify-between items-start gap-3">
              <h3 className="font-inter font-semibold text-[16px] text-[#1A1A2E] leading-snug">{it.name}</h3>
              <span className="font-inter font-bold text-[15px] text-[#4AADDF] whitespace-nowrap">{formatRupiah(it.price)}</span>
            </div>
            <p className="text-[13px] text-[#6B7B8D] mt-1 leading-relaxed">{lang === "en" ? it.desc_en : it.desc_id}</p>
          </motion.div>
        ))}
      </div>

      <div className="fixed bottom-[72px] left-1/2 -translate-x-1/2 w-full max-w-[430px] bg-[#F0F7FF] border-t border-[#E0E8F0] px-4 py-3 z-30">
        <p className="text-[13px] text-[#1A1A2E] mb-2 text-center">
          {T.menuFooter1}<b>{T.ext101}</b>
        </p>
        <button
          data-testid="menu-chat-operator-button"
          onClick={() => navigate("operator")}
          className="w-full h-[46px] rounded-[12px] bg-gradient-to-r from-[#4AADDF] to-[#367ABD] text-white font-semibold text-[15px] active:scale-[0.98] transition-transform"
        >
          {T.chatToOrder}
        </button>
        <p className="text-[11px] text-[#6B7B8D] mt-1.5 text-center">{T.priceNote}</p>
      </div>
    </div>
  );
}
